// TraceabilityPage.jsx

import { Flex, Input } from "antd";
import ReusableTable from "../../Reuseable/ReusableTable/ReusableTable"; // adjust path as needed
import "./TraceabilityPage.scss";
import { useEffect, useState } from "react";
import AgentDetailsModal from "../../components/TraceabilityComp/AgentDetailsModal/AgentDetailsModal";
import { ReactComponent as SearchICon } from "../../assets/Icons/SearchIcon.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import { GeoTagging } from "../../api/GeoTagging";
import { Skeleton } from "antd";

const TraceabilityPage = () => {
  const [pageSize, setPageSize] = useState(10);
  const skeletonData = Array(5).fill({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [geoTable, setGeoTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const { token } = useSelector((state) => state.auth);

  // const handleViewClick = (record) => {
  //   setSelectedAgent(record);
  //   setModalOpen(true);
  // };

  const navigate = useNavigate();

  const fetchGeoTable = async (payload = {}) => {
    if (!token) {
      setError("Authentication token not found");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await GeoTagging(token);
  
      setGeoTable(response.data || []);
    } catch (error) {
      
      setError(
        error.response?.data?.message ||
          error.message ||
          "Failed to fetch geo table data"
      );
      setGeoTable([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGeoTable();
  }, [token]);

  const handleViewClick = (data) => {
    navigate("/geo-tagging/agent-details", { state: data });
  };

  const columns = [
    {
      title: "Agent",
      dataIndex: "role",
      key: "role",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: "Mobile",
      dataIndex: "mobile_no",
      key: "mobile_no",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      ellipsis: true,
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: "Last Active",
      dataIndex: "last_active",
      key: "last_active",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: "Dra Reg. No.",
      dataIndex: "dra_reg_no",
      key: "dra_reg_no",
      render: (text) =>
        loading ? <Skeleton.Input size="small" active /> : text || "-",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) =>
        loading ? (
          <Skeleton.Input size="small" active />
        ) : (
          <button className="viewBtn" onClick={() => handleViewClick(record)}>
            View Details
          </button>
        ),
    },
  ];

  return (
    <Flex vertical gap={20} className="traceabilityPage">
      <Flex className="traceabilityPageHeader">
        <Input
          placeholder="Search"
          allowClear
          className="searchInput"
          // style={{ maxWidth: 300 }}
          prefix={<SearchICon />} // Custom icon here
        />
        <h3 className=" traceabilityPageHeading">Field Agent List</h3>
      </Flex>

      {error && (
        <div style={{ color: "red", textAlign: "center", padding: "20px" }}>
          {error}
        </div>
      )}

      <ReusableTable
        columns={columns}
        dataSource={
          loading ? skeletonData : geoTable?.results?.field_agents || []
        }
        pageSize={pageSize}
        setPageSize={setPageSize}
        // totalItems={geoTable.count}
        totalItems={loading ? 0 : geoTable?.count || 0}
      />
      {/* <AgentDetailsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        agent={selectedAgent}
      /> */}
    </Flex>
  );
};

export default TraceabilityPage;
